module.exports = new __parcel__URL__("shop_machines_space_elixir_storage_v2.5481763e.png").toString();